module.exports = __webpack_public_path__ + "img/gs1_logo.76adc032.png";